// App.js
import React, { useEffect, useState } from 'react';
import activity from '../../../assets/icons/activity.svg';
import referesh from '../../../assets/icons/referesh.svg';
import checkDouble from '../../../assets/icons/checkDouble.svg';
import megaphone from '../../../assets/icons/megaphone.svg';
import requestClose from '../../../assets/icons/requestClose.svg';
import megaphoneFillGreen from '../../../assets/icons/megaphoneFillGreen.svg';
import megaphoneDisabled from '../../../assets/icons/megaphoneDisabled.svg';
import Rejected from '../../../assets/icons/close-circle-fill.svg';
import CancelSharpIcon from '@mui/icons-material/CancelSharp';
import '../../../App.css';
import apiService from '../../../services/apiService';
import { toast } from 'react-toastify';
import ReasonOfRejection from '../reasonOfRejection/ReasonOfRejection';
import RequestInformationModal from '../requestInformationModal/RequestInformationModal';
import ContractConfirmation from 'components/common/contractConfirmation/ContractConfirmation';

const steps = [
  {
    label: 'Request Pending',
    icon: <img src={checkDouble} alt="logo" className="checkDouble-icon" />,
    isActive: false,
  },
  {
    label: 'Approved',
    icon: <img src={referesh} alt="logo" className="referesh-icon" />,
    isActive: false,
  },
  {
    label: 'Announced',
    icon: <img src={megaphone} alt="logo" className="megaphone-icon" />,
    isActive: false,
  },
];

const RequestDetail = ({
  init,
  onClose,
  requestDetails,
  isCluster,
  detailData,
  handleAnnounceClick,
  fetchRequests,
  page,
  rowsPerPag,
}) => {
  const [activitySteps, setActivitySteps] = useState(steps);
  const [requestDetail, setRequestDetail] = useState(requestDetails);
  const [rejectionModal, setRejectionModal] = useState(false);
  const [rejectionReasonModal, setRejectionReasonModal] = useState(false);
  const [requestDetailModal, setRequestDetailModal] = useState(false);
  const [selectedJobIndex, setSelectedJobIndex] = useState(null);
  const [rejectionReasonText, setRejectionReasonText] = useState('');
  const [requestDetailModals, setRequestDetails] = useState(null);
  const [datareason, setData] = useState(null);

  console.log('datareason', datareason);

  useEffect(() => {
    if (requestDetails?.status === 'rejected') {
      setActivitySteps([
        {
          label: 'Request Pending',
          icon: (
            <img src={checkDouble} alt="logo" className="checkDouble-icon" />
          ),
          isActive: false,
        },
        {
          label: 'Rejected',
          icon: <CancelSharpIcon color="error" style={{ fontSize: 40 }} />,
          isActive: false,
        },
        {
          label: 'Approved',
          icon: <img src={referesh} alt="logo" className="referesh-icon" />,
          isActive: false,
        },
        {
          label: 'Announced',
          icon: <img src={megaphone} alt="logo" className="megaphone-icon" />,
          isActive: false,
        },
      ]);
    }
  }, [requestDetails]);

  const colors = ['#EEEBFF', '#cad9fa', '#FEF3EB', '#EBFAFF'];
  const colorPairs = [
    { backgroundColor: '#EEEBFF', textColor: '#2B1664' },
    { backgroundColor: '#EBF1FF', textColor: '#162664' },
    { backgroundColor: '#FEF3EB', textColor: '#6E330C' },
    { backgroundColor: '#EFFAF6', textColor: '#176448' },
    { backgroundColor: '#F6F8FA', textColor: '#525866' },
  ];

  const data = [
    {
      speciality: 'Cardiologist',
      specialityLevel: 'Surgeon',
      practitioners: 14,
      action: 'Announce',
      badgeColor: 'bg-purple-100 text-purple-700',
    },
    {
      speciality: 'Orthopaedic',
      specialityLevel: 'Surgeon',
      practitioners: 16,
      action: 'Announce',
      badgeColor: 'bg-blue-100 text-blue-700',
    },
    {
      speciality: 'Paediatrician',
      specialityLevel: 'Subspecialist',
      practitioners: 20,
      action: 'Announce',
      badgeColor: 'bg-amber-100 text-amber-700',
    },
  ];

  const updateSteps = (status) => {
    let statusToStepIndex = {};

    if (status === 'rejected') {
      statusToStepIndex = {
        under_review: 1,
        pending: 1,
        rejected: 2,
        approved: 3,
        partially_approved: 3,
        announced: 4,
        closed: 4,
      };
    } else {
      statusToStepIndex = {
        under_review: 1,
        pending: 1,
        approved: 2,
        partially_approved: 2,
        announced: 3,
        closed: 3,
      };
    }

    const activeStepsCount = statusToStepIndex[status] || 0;

    return activitySteps.map((step, index) => ({
      ...step,
      isActive: index < activeStepsCount,
    }));
  };

  const transformJobPositions = (jobPositions, status, reason = '') => {
    return {
      job_positions: jobPositions
        .filter((job) => job.status === 'pending')
        .map((job) => ({
          id: job._id,
          status: status,
          reason: reason,
        })),
    };
  };

  const acceptRequest = async (id, payload, isApprove) => {
    try {
      const response = await apiService.put(
        `job-requests/${id}/approve`,
        payload
      );
      const requestDetailResponse = await apiService.get(`job-requests/${id}`);
      if (response?.code === 200) {
        if (requestDetailResponse.code === 200) {
          setRequestDetail({ ...requestDetailResponse?.data });
        }
        fetchRequests(true, page, rowsPerPag);
        const status = isApprove ? 'approved' : 'rejected';
        toast[isApprove ? 'success' : 'info'](`Request is ${status}`, {
          toastId: '19',
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.error || 'Unexpected Error', {
        toastId: '98',
      });
      console.error(error);
    }
  };

  const handleJobAccept = (job) => {
    const payload = transformJobPositions([{ ...job }], 'approved');
    acceptRequest(requestDetail._id, payload, true);
  };

  const handleAccept = () => {
    const payload = transformJobPositions(
      requestDetail.job_positions,
      'approved'
    );
    acceptRequest(requestDetail._id, payload, true);
  };

  const onReject = () => {
    setRejectionModal(true);
  };

  const onRequestDetail = () => {
    setRequestDetailModal(true);
  };

  const handleReject = (rejectionReason) => {
    setRejectionModal(false);
    let payload = {};
    if (selectedJobIndex !== null) {
      payload = transformJobPositions(
        [{ ...requestDetail.job_positions[selectedJobIndex] }],
        'rejected',
        rejectionReason
      );
      acceptRequest(requestDetail._id, payload, false);
    } else {
      payload = transformJobPositions(
        requestDetail.job_positions,
        'rejected',
        rejectionReason
      );
      acceptRequest(requestDetail._id, payload, false);
    }
  };

  const capitalizeFirstCharacter = (str) => {
    if (!str) return ''; // Handle empty or undefined strings
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const user = JSON.parse(localStorage.getItem('user'));

  const handleRequestInfo = async (row, requestDetail) => {
    setRequestDetailModal(false);

    try {
      const payload = {
        additional_information: row,
        is_additional_required: user?.role == 'hospital_manager' ? false : true,
      };
      const endpoint = `job-requests/${requestDetail._id}/send-message`;

      const response = await apiService.post(endpoint, payload, {});
      const requestDetailResponse = await apiService.get(
        `job-requests/${requestDetail._id}`
      );
      if (requestDetailResponse.code === 200) {
        setRequestDetail({ ...requestDetailResponse?.data });
      }
      fetchRequests();
      setRequestDetails(response?.data?.is_additional_required);
      setRequestDetailModal('');
    } catch {}
  };

  const handleAnnouncement = (row, id) => {
    handleAnnounceClick(row, id);
  };

  const reasonFun = (row) => {
    setData(row);
    setRejectionReasonModal(true);
  };

  React.useEffect(() => {
    setRequestDetails(requestDetails?.is_additional_required);
  }, [requestDetails?.is_additional_required]);

  const hasPendingJobPositions = () => {
    if (!requestDetail?.job_positions) {
      return false;
    }
    return requestDetail.job_positions.some(
      (position) => position.status === 'pending'
    );
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 scrollbar-thin scrollbar-thumb-green-500 scrollbar-track-gray-700">
      {rejectionModal && (
        <ReasonOfRejection
          setRejection={setRejectionModal}
          rejectionReason={handleReject}
        />
      )}

      {requestDetailModal && (
        <RequestInformationModal
          setModal={setRequestDetailModal}
          rejectionReasonText={rejectionReasonText}
          onSubmit={handleRequestInfo}
          setRejectionReasonText={setRejectionReasonText}
          requestDetail={requestDetail}
          isCluster={isCluster}
        />
      )}

      {rejectionReasonModal && (
        <ContractConfirmation
          isAccept={3}
          onDismiss={() => {
            setRejectionReasonModal(false);
          }}
          contractDetails={{ reason: datareason?.reason }}
        ></ContractConfirmation>
      )}

      <div className="bg-white rounded-2xl shadow-md w-full max-w-3xl h-[92vh] overflow-y-auto">
        {/* Header Section */}
        <div className="p-4 border-b border-[#E2E4E9] flex justify-between items-center">
          <div className="flex items-center space-x-2">
            {/* Active Badge */}
            <div className="flex items-center rounded-lg px-3 py-1 border border-[#E2E4E9]">
              <span className="w-2 h-2 bg-[#38C793] rounded-full"></span>
              <span className="ml-2 text-gray-700 text-xs">
                {requestDetails?.status == 'under_review'
                  ? 'Pending'
                  : requestDetails?.status == 'partially_approved'
                    ? 'Partially Approved'
                    : capitalizeFirstCharacter(requestDetails?.status)}
              </span>
            </div>

            {/* Request Number */}
            <div className="flex items-center space-x-1">
              <span className="text-black font-medium">#Req No.</span>
              <span className="text-gray-500">|</span>
              <span className="text-gray-500 font-medium">
                {requestDetail?.requestNumber}
              </span>
            </div>
          </div>
          <button
            onClick={() => onClose(false)}
            className="text-gray-400 hover:text-gray-600"
          >
            <img src={requestClose} alt="logo" className="requestClose-icon" />
          </button>
        </div>

        {/* Status Section */}
        {false && (
          <div className="relative bg-[#38C793] text-white px-4 py-3 shadow-md mt-4 mx-4 flex items-center justify-center">
            {/* Centered content with icon and text */}
            <div className="flex items-center justify-center space-x-2">
              {/* Check Icon */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.707a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              {/* Text */}
              <span className="font-medium">Request is Approved</span>
            </div>

            <button
              type="button"
              className="absolute right-5 text-white hover:text-gray-200 focus:outline-none"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M6.293 6.293a1 1 0 011.414 0L10 8.586l2.293-2.293a1 1 0 011.414 1.414L11.414 10l2.293 2.293a1 1 0 01-1.414 1.414L10 11.414l-2.293 2.293a1 1 0 01-1.414-1.414L8.586 10 6.293 7.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </div>
        )}

        {/* Activity Section */}
        <div className="border border-[#E2E4E9] rounded-xl py-2.5 px-3 mx-4 mt-4">
          <div className="border border-[#E2E4E9] rounded-xl p-4">
            {/* Header */}
            <div className="flex items-center space-x-2 mb-4 border-b border-[#E2E4E9] pb-2">
              <img src={activity} alt="logo" className="activity-icon" />
              <span className="text-black font-medium text-lg">Activity</span>
            </div>

            {/* Timeline */}
            <div className="relative flex items-center justify-between">
              {/* Dashed line background */}
              <div className="absolute top-5 left-0 w-full h-0.5">
                <svg
                  width="100%"
                  height="1"
                  viewBox="0 0 100% 1"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <line
                    x1="0"
                    y1="0.5"
                    x2="100%"
                    y2="0.5"
                    stroke="#D9D9D9"
                    strokeDasharray="2 2"
                  />
                </svg>
              </div>

              {updateSteps(requestDetail?.status).map((step, index) => (
                <div
                  key={index}
                  className={`relative z-10 flex flex-col ${index === 0 ? 'items-start' : index === steps.length - 1 ? 'items-end' : 'items-center'} text-center space-y-2`}
                >
                  <div
                    className={`w-10 h-10 flex items-center justify-center rounded-full ${
                      step.isActive
                        ? step.label === 'Rejected'
                          ? 'bg-transparent'
                          : 'bg-green-100'
                        : requestDetail?.status === 'rejected'
                          ? 'bg-gray-50'
                          : 'bg-gray-100'
                    }`}
                  >
                    {step.icon}
                  </div>
                  <span
                    className={`text-sm ${
                      step.isActive
                        ? step.label === 'Rejected'
                          ? 'text-red-500'
                          : 'text-black'
                        : requestDetail?.status === 'rejected'
                          ? 'text-gray-300'
                          : 'text-gray-500'
                    }`}
                  >
                    {step.label}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Details Section */}
        {requestDetail?.creator?.sites && (
          <div className="p-3 border rounded-xl mx-4 mt-4">
            <div className="grid grid-cols-3 divide-x divide-gray-200 px-4">
              <div className="flex flex-col ">
                <h3 className="text-sm font-medium text-gray-500">
                  Hospital Name
                </h3>
                <div className="flex items-center justify-center h-full">
                  <p className="text-lg font-semibold text-gray-900">
                    {requestDetail?.creator?.sites[0]?.name}
                  </p>
                </div>
              </div>
              <div className="flex flex-col items-center">
                <h3 className="text-sm font-medium text-gray-500">Region</h3>
                <div className="flex items-center justify-center h-full">
                  <p className="text-lg font-semibold text-gray-900">
                    {requestDetail?.creator?.region?.name}
                  </p>
                </div>
              </div>
              <div className="flex flex-col items-center">
                <h3 className="text-sm font-medium text-gray-500">City</h3>
                <div className="flex items-center justify-center h-full">
                  <p className="text-lg font-semibold text-gray-900">
                    {requestDetail?.creator?.cluster?.name}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Specialties Section */}
        <div className="mx-4 mt-4 border border-[#E2E4E9] rounded-lg overflow-hidden">
          <table
            className="w-full border-none overflow-hidden"
            style={{ border: 'none' }}
          >
            <thead className="bg-gray-100">
              <tr className="border-b border-[#E2E4E9]">
                <th className="border-[#E2E4E9] py-2 px-3 text-left text-gray-600 font-medium">
                  Medical Speciality
                </th>
                <th className="border-[#E2E4E9] py-2 px-3 text-left text-gray-600 font-medium">
                  Speciality Level
                </th>
                <th className="border-[#E2E4E9] py-2 px-3 text-left text-gray-600 font-medium">
                  No. of Practitioners
                </th>
                <th className="border-[#E2E4E9] py-2 px-3 text-left text-gray-600 font-medium">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {requestDetail?.job_positions?.map((row, index) => {
                const { backgroundColor, textColor } =
                  colorPairs[index % colorPairs.length];
                const randomColor =
                  colors[Math.floor(Math.random() * colors.length)];
                return (
                  <tr
                    key={index}
                    // className={`${index % 2 === 0 ? "bg-white" : "bg-gray-50"}`}
                  >
                    <td
                      className={`${index !== data.length - 1 && 'border-b'} border-[#E2E4E9] p-3 flex items-center gap-2`}
                    >
                      <span
                        className={`px-2 py-1 rounded-full text-sm font-medium`}
                        style={{
                          backgroundColor: backgroundColor,
                          color: textColor,
                        }}
                      >
                        {row.medical_speciality.name}
                      </span>
                    </td>

                    <td
                      className={`${index !== data.length - 1 && 'border-b'} border-[#E2E4E9] p-3 text-gray-700`}
                    >
                      {row.speciality.name}
                    </td>
                    <td
                      className={`${index !== data.length - 1 && 'border-b'} border-[#E2E4E9] p-3 text-gray-700`}
                    >
                      {row.no_of_practitioners}
                    </td>
                    <td
                      className={`${index !== data.length - 1 && 'border-b'} border-[#E2E4E9] p-3 text-green-600`}
                    >
                      {isCluster ? (
                        row.status === 'pending' ? (
                          <div className="flex items-center gap-2">
                            <button
                              className="bg-[#008556] text-white px-3 py-1 rounded text-sm hover:bg-green-600 focus:outline-none"
                              onClick={() => {
                                handleJobAccept(row, index);
                              }}
                            >
                              Accept
                            </button>
                            <button
                              className="border-2 border-red-500 px-3 py-1 rounded text-sm focus:outline-none text-black"
                              onClick={() => {
                                setSelectedJobIndex(index);
                                onReject();
                              }}
                            >
                              Reject
                            </button>
                          </div>
                        ) : row?.status ? (
                          row.status === 'approved' ? (
                            <span className="font-inter font-medium text-[15px] text-[#525866] flex items-center gap-1">
                              <img src={megaphoneFillGreen} alt="logo" />{' '}
                              Approved
                            </span>
                          ) : row.status === 'announced' ? (
                            <span className="font-inter font-medium text-[15px] text-[#525866] flex items-center gap-1">
                              <img src={megaphoneFillGreen} alt="logo" />{' '}
                              Announced
                            </span>
                          ) : row.status === 'rejected' ? (
                            <span
                              onClick={() => reasonFun(row)}
                              className="font-inter font-medium text-[15px] text-[#525866] flex items-center gap-1"
                            >
                              <img src={Rejected} alt="logo" /> Rejected
                            </span>
                          ) : (
                            '-'
                          )
                        ) : (
                          '-'
                        )
                      ) : row?.status === 'pending' ? (
                        user?.role !== 'MoH Manager' ? (
                          <img
                            src={megaphoneDisabled}
                            alt="logo"
                            className="megaphoneDisabled-icon"
                          />
                        ) : (
                          <span className="font-inter font-medium text-[15px] text-[#525866] flex items-center gap-1">
                            <img
                              src={megaphone}
                              alt="logo"
                              className="megaphone-icon"
                            />{' '}
                            Pending
                          </span>
                        )
                      ) : row.status === 'rejected' ? (
                        <span
                          onClick={() => reasonFun(row)}
                          className="font-inter font-medium text-[15px] text-[#525866] flex items-center gap-1"
                        >
                          <img src={Rejected} alt="logo" /> Rejected
                        </span>
                      ) : (
                        <button
                          onClick={() =>
                            row?.status !== 'announced' &&
                            handleAnnouncement(requestDetail, row?._id)
                          }
                          className={`flex items-center gap-2 ${row?.status !== 'announced' ? 'cursor-pointer' : 'cursor-not-allowed'}`}
                          disabled={row?.status === 'announced'}
                        >
                          <img
                            src={megaphoneFillGreen}
                            alt="logo"
                            className="megaphoneFillGreen-icon"
                          />
                          {row?.status === 'announced'
                            ? 'Announced'
                            : user?.role !== 'MoH Manager'
                              ? 'Announce'
                              : 'Not Announced'}
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {!isCluster && requestDetail.is_additional_required && (
          <div className="px-4 pt-4 w-full max-w-4xl mx-auto">
            <div className="border border-[#E2E4E9] pb-[12px] mb-[20px] rounded-lg overflow-hidden">
              <div className="bg-[#F6F8FA] border-b border-[#E2E4E9] py-1.5 text-center text-gray-600 font-medium">
                Additional Information
              </div>
              <div className="p-4 text-center text-gray-700  leading-relaxed w-88  break-words">
                {requestDetails?.additional_information ||
                  'No additional information provided.'}
              </div>
              {user?.role !== 'MoH Manager' && (
                <div className="flex justify-end mr-4">
                  <button
                    className="bg-[#008556] hover:bg-[#008556] text-white font-semibold py-2 px-4 rounded-lg transition"
                    onClick={onRequestDetail}
                  >
                    Respond
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
        {/* Request Addition Info Cluster*/}
        {isCluster &&
          !!requestDetail.additional_information &&
          !requestDetail.is_additional_required && (
            <div className="px-4 pt-4 w-full max-w-4xl mx-auto">
              <div className="border border-[#E2E4E9] pb-[12px] mb-[20px] rounded-lg overflow-hidden">
                <div className="bg-[#F6F8FA] border-b border-[#E2E4E9] py-1.5 text-center text-gray-600 font-medium">
                  Additional Information
                </div>
                <div className="p-4 text-center text-gray-700  leading-relaxed w-88  break-words">
                  {requestDetails?.additional_information ||
                    'No additional information provided.'}
                </div>
              </div>
            </div>
          )}

        {/* Notes Section */}
        {requestDetail?.notes && (
          <div
            className="px-4 pt-4 w-full max-w-4xl mx-auto  
                 "
          >
            <div className="border border-[#E2E4E9] pb-[12px] mb-[20px] rounded-lg overflow-hidden">
              <div className="bg-[#F6F8FA] border-b border-[#E2E4E9] py-1.5 text-center text-gray-600 font-medium">
                Notes
              </div>
              <div className="p-4 text-center text-gray-700 leading-relaxed w-88  break-words">
                {requestDetail?.notes}
              </div>
            </div>
          </div>
        )}

        {isCluster &&
          (requestDetail?.status === 'under_review' ||
            hasPendingJobPositions()) && (
            <div className="p-4 flex justify-between gap-4 border-t mt-4">
              <button
                onClick={onReject}
                type="button"
                className="w-full px-4 py-2 border-2 border-red-500 text-gray-700 rounded-lg font-semibold"
              >
                Reject All
              </button>

              <button
                onClick={handleAccept}
                type="submit"
                className="font-semibold w-full px-4 py-2 bg-[#008556] text-white rounded-lg"
              >
                Accept All
              </button>
              <button
                disabled={
                  requestDetail.additional_information !== '' &&
                  requestDetail.is_additional_required
                }
                onClick={onRequestDetail}
                type="button"
                className={`font-semibold w-full px-4 py-2 ${requestDetail.additional_information !== '' && requestDetail.is_additional_required ? 'bg-[#efa472]' : 'bg-[#eb7b2f]'} text-white rounded-lg`}
              >
                {!!requestDetail.additional_information &&
                !requestDetail.is_additional_required
                  ? 'Request Details'
                  : 'Details Requested'}
              </button>
            </div>
          )}
      </div>
    </div>
  );
};

export default RequestDetail;
